<template>
<div class="chapter">
<div class="inner_page">
<div id="fm2">
<p class="author"><em class="italic">Also by Christopher Brookmyre</em></p>
<p class="author1"><span>QUITE UGLY ONE MORNING</span></p>
<p class="author1"><span>COUNTRY OF THE BLIND</span></p>
<p class="author1"><span>NOT THE END OF THE WORLD</span></p>
<p class="author1"><span>ONE FINE DAY IN THE MIDDLE OF THE NIGHT</span></p>
<p class="author1"><span>BOILING A FROG</span></p>
<p class="author1"><span>A BIG BOY DID IT AND RAN AWAY</span></p>
<p class="author1"><span>THE SACRED ART OF STEALING BE MY ENEMY</span></p>
<p class="author1"><span>ALL FUN AND GAMES UNTIL SOMEBODY LOSES AN EYE</span></p>
<p class="author1"><span>A TALE ETCHED IN BLOOD AND HARD BLACK PENCIL</span></p>
<p class="author1"><span>ATTACK OF THE UNSINKABLE RUBBER DUCKS</span></p>
<p class="author1"><span>A SNOWBALL IN HELL</span></p>
<p class="author1"><span>PANDAEMONIUM</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// also_by.vue?289f4e0f